import * as React from 'react'

const TurkCodePage = () => (<div style={{fontSize: '24px', display: 'flex', justifyContent: 'center', marginTop: '100px'}}>
  <h1>Thank you for completing the Quill Grammar activity.</h1>
  <p>
    Your unique code is ij3982rmf9.
  </p>
</div>)

export default TurkCodePage
